import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import LwtApp from '@lwtears/lwt-common-frontend/lib/LwtApp';
import { hasAuthCookies } from 'util/auth-cookie-util';
import GatedApp from 'components/app/GatedApp';
import i18n from 'translations';
import Config from 'config';
import ApolloProvider from 'state/providers/ApolloProvider';
import AuthWrapper from 'components/modules/AuthWrapper';
import { sendEventLoginSuccess } from 'util/telemetry-util';
import { ThemeProvider as MaterialThemeProvider } from '@mui/material/styles';
import defaultTheme from 'themes/defaultTheme';
import './index.css';

const App = (): React.ReactElement => {
  const msalInstance = new PublicClientApplication(Config.auth as Configuration);

  return (
    <MaterialThemeProvider theme={defaultTheme}>
      <MsalProvider instance={msalInstance}>
        <LwtApp i18n={i18n}>
          <AuthWrapper
            useAuth={!hasAuthCookies()}
            instance={msalInstance}
            onLoginSuccess={sendEventLoginSuccess}
          >
            <ApolloProvider>
              <GatedApp />
            </ApolloProvider>
          </AuthWrapper>
        </LwtApp>
      </MsalProvider>
    </MaterialThemeProvider>
  );
};

export default App;
